import { AccountData, Follower } from "@markit/common.types";
import { getDocs, limit, query, where } from "../firebase";
import { fetchSingleUser } from "./FetchSingleData";
import { getUserFollowersRef } from "./FirebaseUtils";
import {
  checkPhoneNumberValidCountryType,
  normalizePhoneInputToE164,
} from "./FormatPhoneNumber";
import { PhoneErrorType, PhoneNumberValidType } from "@markit/common.utils";

// Validate phone number input
export const showPhoneInputError = (
  phoneNumber: string,
  setShowPhoneNumberError: (error: PhoneErrorType) => void
) => {
  let error = false;
  // Check if phone number is empty
  if (!phoneNumber || (phoneNumber && phoneNumber.length === 0)) {
    setShowPhoneNumberError({
      isError: true,
      message: "You must enter a phone number.",
    });
    error = true;
  } else if (
    checkPhoneNumberValidCountryType(phoneNumber) ===
    PhoneNumberValidType.INVALID
  ) {
    // Check if phone number format is valid based on the country code
    setShowPhoneNumberError({
      isError: true,
      message: "Please enter a valid mobile phone number.",
    });
    error = true;
  }
  return error;
};

// Searches for a follower user by phone number
export const searchByPhoneNumber = async (
  searchTerm: string,
  uid: string,
  followingAccountData: AccountData[]
): Promise<{ user: AccountData; followerData: Follower } | undefined> => {
  // Check if the phone number is an exact match to a follower
  const normalizedPhoneNumber = normalizePhoneInputToE164(searchTerm);
  if (!normalizedPhoneNumber) {
    return;
  }
  const followersRef = getUserFollowersRef(uid);
  const followersQuery = query(
    followersRef,
    where("phoneNumber", "==", normalizedPhoneNumber),
    limit(1)
  );
  const followersSnapshot = await getDocs(followersQuery);
  if (!followersSnapshot.empty) {
    const followerData = followersSnapshot.docs[0].data();
    const userData = await fetchSingleUser(
      followerData.uid,
      followingAccountData
    );
    if (userData) {
      return {
        user: userData,
        followerData: followersSnapshot.docs[0].data(),
      };
    }
  }
};

// Returns a description when there are no results from searching by phone number
export const searchByPhoneNumberNoResults = (searchTerm: string) => {
  return normalizePhoneInputToE164(searchTerm)
    ? "Check the phone number format and try again, or switch to name search."
    : "You have an incomplete or invalid phone number. Must be an exact match. No search made yet.";
};
